import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Warning from "@mui/icons-material/Warning";
import Work from "@mui/icons-material/Work";
import Notifications from "@mui/icons-material/Notifications";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import PricingProgressBar from "./components/PricingProgressBar";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { useDispatch, useSelector } from "react-redux";
import { fetchClusterDetails } from "../../../redux/slices/vendorClusterSlice";
import { useLocation } from "react-router-dom";

const ClusterDashboard = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(location.search);
  const clusterId = query.get("clusterId");
  useEffect(() => {
    dispatch(fetchClusterDetails(clusterId));
  }, [clusterId]);
  const tabs = ["All", "Manufacturing", "PDI", "Dispatch"];
  const [activeTab, setActiveTab] = useState("All"); // Default active tab

  const keyAccountManager = [
    {
      id: 1,
      image: "/assests/vendorPortalImages/maleEmoji1.webp",
      name: "Abhimanyu Chauhan",
      phone: "+91-7565656576",
      email: "abhimanyu@pixell.in",
    },
    {
      id: 2,
      image: "/assests/vendorPortalImages/maleEmoji2.webp",
      name: "Neeraj singh Attri",
      phone: "+91-7565656576",
      email: "neeraj@pixell.in",
    },
  ];

  const paymentData = [
    {
      id: 1,
      name: "abhimanyu chauhan",
      date: "23 June 2025",
      amount: "70,000",
    },
    {
      id: 2,
      name: "Neeraj attri",
      date: "24 June 2025",
      amount: "50,000",
    },
    {
      id: 3,
      name: "manish Nagar",
      date: "28 June 2025",
      amount: "90,000",
    },
  ];

  const notifications = [
    {
      id: 1,
      type: "payment",
      title: "Payment Notification",
      description: "Lorem Ipsum is simply dummy text of the printing.",
      time: "10 mins ago",
      icon: <CheckCircle sx={{ color: "#22c55e" }} />,
      bgColor: "#e8f5e9",
    },
    {
      id: 2,
      type: "issue",
      title: "Issues Notification",
      description: "Friday, February 10, 2023 at 5:57 PM",
      icon: <Warning sx={{ color: "#ef4444" }} />,
      bgColor: "#ffebee",
      action: "Undo",
    },
    {
      id: 3,
      type: "job",
      title: "Jobs Notification",
      description: "Lorem Ipsum is simply dummy text.",
      time: "10 mins ago",
      icon: <Work sx={{ color: "#a855f7" }} />,
      bgColor: "#f3e5f5",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
    {
      id: 4,
      type: "notification",
      title: "Notification title",
      description: "",
      time: "10 mins ago",
      icon: <Notifications sx={{ color: "#3b82f6" }} />,
      bgColor: "#e3f2fd",
    },
  ];

  const clusterData = [
    {
      lotNumber: "Lot 1",
      quantity: "3 Nos",
      status: "Manufacturing",
      items: [
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
      ],
    },
    {
      lotNumber: "Lot 2",
      quantity: "4 Nos",
      status: "Printing",
      items: [
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
      ],
    },
    {
      lotNumber: "Lot 3",
      quantity: "7 Nos",
      status: "Manufacturing",
      items: [
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
        {
          image: "/assets/images/veterinary-surgery.webp",
          dimensions: "10 Ft. 8 In X 10 Ft. 8 In X 9 In",
          buttonText: "View Details",
        },
      ],
    },
  ];

  return (
    <div>
      {/* Header section  */}
      <div className=" flex justify-between">
        <div className=" flex items-center gap-4">
          {/* <IconButton
            size="small"
            sx={{
              p: 0.5, // smaller padding
              boxShadow: 3,
              width: 30,
              height: 30,
            }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton> */}
          <span className=" text-xl lg:text-2xl font-semibold">
            ShopFront Signage
          </span>
        </div>
        <div className=" flex gap-4 items-center">
          <div className=" bg-[#FFECDC] text-[#FFA04F] rounded-full px-4 py-1">
            Fabrication
          </div>
          <div className="bg-[#F2F5F8] text-black text-sm px-4 py-1 rounded-full flex items-center gap-2 ">
            <CalendarTodayIcon fontSize="small" />
            23 Sep 2024 - 30 Nov 2024
          </div>
        </div>
      </div>
      {/* middle section */}
      <div className=" grid grid-cols-1 lg:grid-cols-3 py-4 gap-4">
        {/* first card */}
        <div
          className=" p-4 rounded-3xl"
          style={{
            boxShadow: "0 10px 15px rgba(0, 0, 0, 0.3)",
          }}
        >
          {/* Sow and coral cards */}
          <div className=" flex justify-around items-center ">
            <div className="relative w-full h-32  flex flex-col items-center justify-center  cursor-pointer rounded-xl">
              <img
                src="/assests/vendorPortalImages/dashboardCard2.webp"
                alt="paymentcard"
                className="   w-full h-auto absolute"
              />
              <div className="relative z-10 text-white">
                <CloudDownloadIcon />
              </div>
              <div className="relative z-10 text-sm text-white">
                Product Coral File
              </div>
            </div>
            <div className="relative w-full h-32  flex flex-col items-center justify-center  cursor-pointer rounded-xl">
              <img
                src="/assests/vendorPortalImages/dashboardCard1.webp"
                alt="paymentcard"
                className="   w-full h-auto absolute"
              />
              <div className="relative z-10 text-white">
                <VisibilityOutlinedIcon />
              </div>
              <div className="relative z-10 text-sm text-white">View SOW</div>
            </div>

            <div></div>
          </div>

          {/* key account manager */}
          <div className=" rounded-2xl p-2">
            <div className=" mx-2 py-2 border-b-2 text-xl font-bold">
              key Account Manager
            </div>
            <div className=" py-2">
              {keyAccountManager.map((account, index) => {
                return (
                  <div
                    key={account.id}
                    className=" bg-[#F6F8FA] rounded-2xl flex mb-2 gap-6"
                  >
                    <img
                      src={account.image}
                      alt="emoji"
                      className="w-20 h-20 object-cover"
                    />
                    <div className=" flex flex-col text-gray-500">
                      <span className=" text-lg font-semibold text-black">
                        {account.name}
                      </span>
                      <span className=" ">{account.phone}</span>
                      <span>{account.email}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* second card payment */}
        <div
          className=" p-4 rounded-3xl"
          style={{
            boxShadow: "0 10px 15px rgba(0, 0, 0, 0.3)",
          }}
        >
          {/* heading */}
          <div className=" flex justify-between mx-2 border-b-2 py-2">
            <span className=" text-xl font-semibold"> Payments</span>
            <div className=" text-blue-500 font-medium border-b-2 border-blue-500">
              <span>View</span>
              <ArrowOutwardOutlinedIcon fontSize="small" />
            </div>
          </div>
          {/* NEFT & RTGS */}
          <div className=" w-full my-2">
            <img
              src="/assests/vendorPortalImages/neft.webp"
              alt="paymentcard"
              className="w-full h-auto"
            />
          </div>
          {/* payment progress bar */}
          <div>
            <PricingProgressBar currentAmount={192000} targetAmount={420000} />
          </div>

          {/* payment cards details */}
          <div className="mt-4 overflow-y-auto max-h-[120px]">
            {paymentData.map((paymentDataItem, index) => (
              <div className=" bg-[#F6F8FA] p-2 flex mb-2 items-center gap-6 rounded-2xl">
                <div className=" bg-[#23272E0D] p-2  rounded-2xl">
                  <CurrencyRupeeOutlinedIcon fontSize="large" />
                </div>
                <div className=" flex flex-col">
                  <span>{`₹ ${paymentDataItem.amount}`}</span>
                  <div className="flex gap-1">
                    <div className=" flex justify-center items-center text-sm text-gray-600">
                      <PermIdentityOutlinedIcon fontSize="small" />
                      <span className="">{paymentDataItem.name}</span>
                    </div>
                    <div className=" flex justify-center items-center text-sm text-gray-600">
                      <FiberManualRecordIcon
                        sx={{ height: "10px", width: "10px" }}
                      />
                      <span>{paymentDataItem.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* third card notifications */}
        <div>
          <Card
            elevation={1}
            sx={{
              borderRadius: 5,
              boxShadow: 6,
              p: 2,
              width: "100%", // takes full width of parent
              minHeight: "100%",
              margin: "auto",
            }}
          >
            <Box
              mx={2}
              py={0.5}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              borderBottom={2}
              borderColor="divider"
              mb={1}
            >
              <Typography variant="h6" fontWeight={600}>
                Notifications
              </Typography>
              <div className=" text-blue-500 font-medium border-b-2 border-blue-500">
                <span>View</span>
                <ArrowOutwardOutlinedIcon fontSize="small" />
              </div>
            </Box>

            <CardContent sx={{ pt: 0 }}>
              {/* Date Row */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 1,
                  gap: 0.5,
                  color: "text.secondary",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                24 Jun 2024
                <KeyboardArrowDown fontSize="small" />
              </Box>

              {/* Notification List */}
              <List
                disablePadding
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  overflowY: "auto",
                  maxHeight: "260px",
                  p: 1,
                }}
              >
                {notifications.map((notification) => (
                  <ListItem
                    key={notification.id}
                    sx={{
                      borderRadius: 2,
                      bgcolor: "#f9fafb",
                      display: "flex",
                      alignItems: "flex-start",
                      boxShadow: 2,
                    }}
                  >
                    {/* Icon */}
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          bgcolor: notification.bgColor,
                          width: 40,
                          height: 40,
                        }}
                      >
                        {notification.icon}
                      </Avatar>
                    </ListItemAvatar>

                    {/* Title, Time, and Description */}
                    <ListItemText
                      primary={
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography fontSize={14} fontWeight={600}>
                            {notification.title}
                          </Typography>
                          {notification.time && (
                            <Typography fontSize={12} color="text.secondary">
                              {notification.time}
                            </Typography>
                          )}
                        </Box>
                      }
                      secondary={
                        notification.description && (
                          <Typography
                            fontSize={12}
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            {notification.description}
                          </Typography>
                        )
                      }
                    />

                    {/* Action (like Undo) */}
                    {notification.action && (
                      <ListItemSecondaryAction
                        sx={{ top: "50%", transform: "translateY(-50%)" }}
                      >
                        <Button
                          size="small"
                          sx={{ fontSize: 12 }}
                          color="primary"
                        >
                          {notification.action}
                        </Button>
                      </ListItemSecondaryAction>
                    )}
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </div>
      </div>
      {/* Third section */}
      <div className=" mt-4 px-2 rounded-2xl">
        <div className=" bg-black rounded-2xl">
          {/* header */}
          <div className="w-full bg-black flex justify-around  items-center rounded-t-2xl">
            <div className="w-1/3 bg-white">
              <div className="bg-black  h-12 rounded-t-2xl flex items-center px-3">
                <span className="text-white text-xl font-semibold">Work</span>
              </div>
            </div>
            <div className="w-1/3 bg-white overflow-x-auto flex justify-around items-center h-12 rounded-b-2xl">
              {tabs.map((tab) => (
                <span
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`cursor-pointer text-lg rounded-2xl px-4 transition-all duration-200 ${
                    activeTab === tab ? "bg-black text-white" : "text-gray-700"
                  }`}
                >
                  {tab}
                </span>
              ))}
            </div>
            <div className="w-1/3 bg-white">
              <div className=" bg-black h-12 rounded-t-2xl"></div>
            </div>
          </div>
          {/* devider */}
          <div className=" mt-2 h-[1px] mx-2 bg-gray-500"></div>

          {/* cluster details */}
          <div className=" flex gap-4 p-6  w-full">
            <div className=" w-1/3">
              <img
                src="/assests/vendorPortalImages/map.webp"
                alt="map"
                className="w-full h-[600px]"
              />
            </div>
            <div className=" w-2/3 overflow-x-auto flex gap-4">
              {clusterData.map((cluster, index) => (
                <div className=" bg-[#252525] min-w-[400px] p-2 rounded-2xl">
                  {/* header */}
                  <div className=" px-2 flex justify-between items-center text-white">
                    <div className=" text-lg font-semibold">
                      {cluster.lotNumber}
                    </div>
                    <div className=" text-white flex gap-2">
                      <span className=" rounded-full px-2 bg-[#656565]">
                        {cluster.quantity}
                      </span>
                      <span className="rounded-full px-2 bg-[#656565]">
                        {cluster.status}
                      </span>
                    </div>
                  </div>

                  {/* devider */}
                  <div className=" mx-1 mt-2 h-[1px]  bg-slate-400"></div>

                  {/* lots data */}
                  {cluster.items.map((item, index) => (
                    <div className=" mt-4">
                      <div className=" p-2 bg-[#1D1D1D] flex gap-10 items-center rounded-2xl">
                        <div className=" h-20 w-24 flex justify-center items-center">
                          <img
                            src="/assests/vendorPortalImages/map.webp"
                            alt="map"
                            className="w-full h-16 rounded-2xl  object-cover"
                          />
                        </div>
                        <div className=" flex flex-col justify-center text-white gap-2">
                          <span>{item.dimensions}</span>
                          <span className=" flex justify-center">
                            <button className=" w-full border-[1px] text-blue-600 border-blue-600 rounded-lg">
                              View Details
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClusterDashboard;
